import { Close, LeftArrowMini } from 'hatch-components';
import PropTypes from 'prop-types';
import React from 'react';
import Backdrop from 'root/components/molecules/Backdrop';

import {
  StyledCloseButton,
  StyledDrawer,
  StyledDrawerHeader,
  StyledHeaderLeftWrapper,
  StyledTitle,
} from './styles';

const Drawer = ({
  className,
  transition,
  title,
  headerLeft: HeaderLeft,
  onClose,
  children,
  withBackdrop,
}) => (
  <>
    {withBackdrop && (
      <Backdrop onClick={onClose} transition={transition} withColor />
    )}
    <StyledDrawer className={className} transition={transition}>
      <StyledDrawerHeader>
        <StyledCloseButton onClick={onClose} showOnMobile variant="empty">
          <LeftArrowMini />
        </StyledCloseButton>
        {title && !HeaderLeft ? <StyledTitle>{title}</StyledTitle> : null}
        {HeaderLeft ? (
          <StyledHeaderLeftWrapper>
            <HeaderLeft />
          </StyledHeaderLeftWrapper>
        ) : null}
        <StyledCloseButton onClick={onClose} variant="empty">
          <Close />
        </StyledCloseButton>
      </StyledDrawerHeader>
      {children}
    </StyledDrawer>
  </>
);

Drawer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  headerLeft: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
  transition: PropTypes.string.isRequired,
  withBackdrop: PropTypes.bool,
};

Drawer.defaultProps = {
  children: undefined,
  className: '',
  headerLeft: null,
  onClose: () => {},
  title: '',
  withBackdrop: true,
};

export default Drawer;
